<template lang="html">
  <div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('date de naissance')}">
					<label for="date de naissance">Date de naissance</label>
					<input v-validate="'required'" type="date" name="date de naissance" v-model="birthdate">
				</div>
				<div class="error-message">{{ errors.first('date de naissance')}}</div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('métier')}">
					<label for="métier">Métier *</label>
					<input v-validate="'required'" type="text" name="métier" v-model="job">
				</div>
				<div class="error-message">{{ errors.first('métier')}}</div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('catégorie professionnelle')}">
					<label for="catégorie professionnelle">Catégorie Professionnelle</label>
					<custom-select v-validate="'required|select'" v-model="csp" name="catégorie professionnelle" :items="cspList" :selected="csp" @change="csp=$event"></custom-select>
				</div>
				<div class="error-message">{{ errors.first('catégorie professionnelle')}}</div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('statut matrimonial')}">
					<label for="catégorie professionnelle">Statut Matrimonial</label>
					<custom-select v-validate="'required|select'" v-model="maritalStatus" name="statut matrimonial" :items="maritalStatusList" :selected="maritalStatus" @change="maritalStatus=$event"></custom-select>
				</div>
				<div class="error-message">{{ errors.first('statut matrimonial')}}</div>
			</div>
		</form>
		<div class="asterisk-container">
			<div class="item">
				* Votre profession actuelle ou métier exercé avant votre départ en retraite
			</div>
		</div>
  </div>
</template>

<script>
import CSP from '@/common/components/MyPatrimonialLandscape/data/CSP.js'
import MaritalStatus from '@/common/components/MyPatrimonialLandscape/data/MaritalStatus.js'
import CustomSelect from '@/common/components/Form/CustomSelect'
import { mapGetters } from 'vuex'

export default {
	name: 'YourInformations',
	components: {
		CustomSelect
	},
	data () {
		return {
			birthdate: null,
			job: null,
			csp: null,
			maritalStatus: null,
			maritalStatusList: MaritalStatus,
			cspList: CSP
		}
	},
	mounted () {
		this.birthdate = (this.estate.birthdate) ? this.estate.birthdate.toString().split('/').reverse().join('-') : null
		this.job = this.estate.job
		this.csp = (this.estate.csp !== null) ? this.estate.csp : this.cspList[0]
		this.maritalStatus = (this.estate.maritalStatus !== null) ? this.estate.maritalStatus : this.maritalStatusList[0]
	},
	methods: {
		validate () {
			return this.$validator.validate()
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'YOUR_INFORMATIONS',
							data: {
								birthdate: this.birthdate,
								job: this.job,
								csp: this.csp,
								maritalStatus: this.maritalStatus
							},
							fromStart: false
						}).then(() => {
							resolve()
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// YourInformations.vue?289a925a